import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from "vuetify/lib/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        secondary: "#FFF212",
        primary: {
          base: "#1C2A5E",
          lighten1: "#C7EAFB",
          lighten2: "#009FE4",
        },
        grey: {
          base: "#B9B7BD",
          lighten1: "#F7F7F7",
          lighten2: "#87868A",
          lighten3: "2C2C2C",
        },
      },
    },
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
  icons: {
    iconfont: "fa",
  },
});
